import { Component, input } from '@angular/core';
import { faClone } from '@fortawesome/free-solid-svg-icons';
import {
  BaseButtonAppearance,
  BaseButtonVariant,
  ButtonComponent,
  IconButtonComponent,
} from '@group24ag/flowkit';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-my-buttons',
  imports: [ButtonComponent, IconButtonComponent],
  templateUrl: 'buttons.component.html',
})
export class ButtonsComponent {
  header = input.required<string>();
  appearance = input.required<BaseButtonAppearance>();
  variants: BaseButtonVariant[] = ['accent', 'info', 'default', 'warn'];
  buttonText = 'Save & Next';

  constructor(library: FaIconLibrary) {
    library.addIcons(faClone);
  }
}
